import PageTitle from "../misc/PageTitle";
import PublicPackagesPage from "./PublicPackagesPage";
import PublicPackagePage from "./PublicPackagePage";
import { Route } from "react-router-dom";
import type { UserRole } from "../auth/auth";

export function PackagesRoutes1({ role }: { role: UserRole | null }) {
  return (
    <Route path="public/packages">
      <Route
        index
        element={
          <>
            <PageTitle title="pakiety" />
            <PublicPackagesPage />
          </>
        }
      />
      <Route
        path=":packageId"
        element={
          <>
            <PageTitle title="szczegóły pakietu" />
            <PublicPackagePage role={role} />
          </>
        }
      />
    </Route>
  );
}
